import { renderTodo, addBtnHandler } from './renderTodo.js'
import { stateHandler } from './stateFilter.js'
import { addTodoBtnHandler, addTodoListBtnHandler, modalCloseHandler } from './modal.js'
import { deleteHandler, changeTodo } from './editTodo.js'
import randomMusic from './randomLyric.js'

renderTodo()